"use strict";

exports.__esModule = true;
exports.sendRequest = exports.getFullList = exports.createRequest = void 0;
var _awsAmplify = require("aws-amplify");
var _axios = _interopRequireDefault(require("axios"));
var _ = require("./");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const createRequest = (useAuthentication, cancelToken = undefined) => {
  //console.dir(cancelToken);

  const request = {};
  request.baseURL = process.env.REACT_APP_API;
  //request.cancelToken = cancelToken;

  if (useAuthentication === true) {
    return _awsAmplify.Auth.currentSession().then(data => {
      request.headers = {
        Authorization: data.idToken.jwtToken
      };
      return request;
    }).catch(err => {
      console.log("No user authenticated");
    });
  } else {
    return Promise.resolve(request);
  }
};
exports.createRequest = createRequest;
const sendRequest = request => {
  return (0, _axios.default)({
    method: request.method,
    baseURL: request.baseURL,
    url: request.url,
    data: request.data,
    headers: request.headers,
    cancelToken: request.cancelToken
  });
};
exports.sendRequest = sendRequest;
const getFullList = (request, endpoint, queryParams, skip, take, accumulatedObjects = []) => {
  return new Promise((resolve, reject) => {
    let parsedParams;
    queryParams.take = take;
    queryParams.skip = skip || 0;
    parsedParams = (0, _.parseParamShorthands)(queryParams);
    request.method = "get";
    request.url = `${endpoint}${(0, _.paramsToString)(parsedParams)}`;
    sendRequest(request).then(response => {
      Array.prototype.push.apply(accumulatedObjects, response.data);
      if (skip + take < response.headers["x-total-count"]) {
        skip = skip + take;
        resolve(getFullList(request, endpoint, queryParams, skip, take, accumulatedObjects));
      }
      response.data = accumulatedObjects;
      if (response.data.length >= response.headers["x-total-count"]) {
        resolve(response);
      }
    }).catch(error => {
      console.dir(error);
    });
  }).catch(error => {
    console.dir(error);
  });
};
exports.getFullList = getFullList;